import Icon from "@mui/material/Icon";

const adminRoutes = [
  {
    name: "databases",
    icon: <Icon>storage</Icon>,
    collapse: [
      {
        name: "chats",
        route: "/admin/chats-database",
      },
      {
        name: "gebruikers",
        route: "/admin/databases/users",
      },
    ],
  },
  {
    name: "chatbot",
    icon: <Icon>smart_toy</Icon>,
    collapse: [
      {
        name: "chatbot logica",
        route: "/admin/agents",
      },
      {
        name: "chatbot instellingen",
        route: "/admin/chatbot-defaults",
      },
    ],
  },
  {
    name: "prijzen",
    icon: <Icon>attach_money</Icon>,
    route: "/admin/pricing",
  },
  {
    name: "account",
    icon: <Icon>contacts</Icon>,
    collapse: [
      {
        name: "uitloggen",
        route: "/authenticatie/uitloggen",
      },
    ],
  },
];

export default adminRoutes;
